import {Component, OnInit, ViewChild} from '@angular/core';
import {AbstractDataProvider} from '../AbstractDataProvider';
import {NgxUiLoaderService} from 'ngx-ui-loader';
import {Observable, Subject} from 'rxjs';
import {
  GridComponent,
  ColumnComponent,
} from '@progress/kendo-angular-grid';
import {SortDescriptor} from '@progress/kendo-data-query';
import {AuthServiceCustom} from 'src/shared/service/auth.service';
import {GenericFilterModel} from '../security/QueryStringParam';
import {debounceTime, finalize} from 'rxjs/operators';
import {FilterModel, Fund, TimeFilter} from '../../shared/model/interfaces';
import {DOCUMENT_TYPES, TIME_FILTERS} from '../../shared/staticData/filters-data';
import {getErrorMessageText, toUpperCase} from '../helper';
import {DictionaryPipe} from '../../shared/pipes/dictionary.pipe';

@Component({
  selector: 'app-client-statement',
  templateUrl: './client-statement.component.html',
  styleUrls: ['./client-statement.component.scss'],
  providers: [DictionaryPipe]
})
export class ClientStatementComponent implements OnInit {
// export class ClientStatementComponent implements OnInit, AfterViewInit {
  public statements = [];
  display = false;
  alertMessage: string;
  totalRecords: number;
  public loading: boolean;
  public rowPerPage = 50;
  public currentPageNo = 1;
  public data: Observable<any>;
  public introText: string;
  @ViewChild(GridComponent) kendoGridComponent: GridComponent;
  @ViewChild('txtFromDistDate') txtFromDistDate;
  @ViewChild('txtToDistDate') txtToDistDate;
  public sort: SortDescriptor[] = [{field: 'StatementDate', dir: 'desc'}];
  downloadDocumentImagUrl: string = this.abstractDataProvider.baseUrl + 'api/File/FileDownloadFromDocumentImage?SeqNum=';
  downloadDocumentImagZipUrl: string = this.abstractDataProvider.baseUrl + 'api/File/FileDownloadFromDocumentsImageZip?UniqueListKey=';
  skipRecords = 0;
  year = 0;
  fund = '0';
  documentType = '';
  daysToGoBack = 'P6M';
  timeFilters: TimeFilter[] = TIME_FILTERS;
  funds: Fund[] = [];
  documentTypeList: FilterModel[] = DOCUMENT_TYPES;
  rowSelectionList = [];
  // listOfSelectedStatementsForDownload = [];
  private allDataLoaded = false;
  private searchRequest = new Subject();
  isBrokerType: boolean;
  houseAccount: boolean;

  name: string;
  accountNum: string;
  taxId: string;

  get isAllSelected() {
    return this.statements.length === this.rowSelectionList.length;
  }

  constructor(private abstractDataProvider: AbstractDataProvider,
              private ngxService: NgxUiLoaderService,
              private authService: AuthServiceCustom,
              private dictionaryPipe: DictionaryPipe) {
  }


  ngOnInit() {
    this.isBrokerType = this.authService.UserType === 'B';
    this.makeAPICallGetData(this.rowPerPage);
    this.getIntroText();
    this.abstractDataProvider.getData('api/Fund/GetFunds').pipe(finalize(() => {
      this.getGridConfig();
      this.ngxService.stop();
    }))
      .subscribe((funds) => {
          this.funds = funds.Funds;
        },
        error => {
          this.display = true;
          this.alertMessage = getErrorMessageText(error);
        });

    this.searchRequest
      .pipe(debounceTime(300))
      .subscribe(() => this.search());
  }

  // ngAfterViewInit() {
  //   this.kendoGridComponent.selectionChange.subscribe((event) => {
  //     this.rowSelected(event);
  //   });
  // }

  sortChange(sort: SortDescriptor[]): void {
    if (sort && sort[0].field == 'seqNum') {
      return;
    }
    this.currentPageNo = 1;
    this.allDataLoaded = false;
    this.sort = sort;
    this.loading = true;
    this.statements = [];
    this.skipRecords = 0;
    this.makeAPICallGetData(this.rowPerPage);
  }

  loadMore(countToLoad = null, afterLoad: () => void = null) {
    if (this.loading)
      return;

    if (!this.allDataLoaded) {
      this.skipRecords = this.statements.length;
      this.loading = true;
      this.makeAPICallGetData(countToLoad || this.rowPerPage, afterLoad);
    } else {
      afterLoad();
    }
  }

  makeAPICallGetData(countToLoad: number, afterLoad: () => void = null) {
    const genericFilterModel = new GenericFilterModel();
    genericFilterModel.Filters = [];
    genericFilterModel.Filters.push({Key: 'fund', Value: this.fund});
    genericFilterModel.Filters.push({Key: 'daysToGoBack', Value: this.daysToGoBack});
    if (this.daysToGoBack === 'DR') {
      genericFilterModel.Filters.push({Key: 'txtFromDistDate', Value: this.txtFromDistDate.Value});
      genericFilterModel.Filters.push({Key: 'txtToDistDate', Value: this.txtToDistDate.Value});
    }
    genericFilterModel.Filters.push({Key: 'userType', Value: 'I'});

    genericFilterModel.Filters.push({Key: 'name', Value: toUpperCase(this.name)});
    genericFilterModel.Filters.push({Key: 'accountNum', Value: toUpperCase(this.accountNum)});
    genericFilterModel.Filters.push({Key: 'taxId', Value: toUpperCase(this.taxId)});

    genericFilterModel.PageNo = this.currentPageNo;
    genericFilterModel.PageSize = countToLoad;
    genericFilterModel.SortField = this.sort[0].field;
    genericFilterModel.SortOrder = this.sort[0].dir;
    genericFilterModel.SkipRecords = this.skipRecords;
    if (this.isBrokerType) {
      genericFilterModel.Filters.push({Key: 'houseAccount', Value: Boolean(this.houseAccount).toString()});
    }
    // this.listOfSelectedStatementsForDownload = [];
    this.rowSelectionList = [];
    this.abstractDataProvider.postData(genericFilterModel, 'api/Statement/GetStatementForClientStatementPage').subscribe((statement) => {
        this.loading = false;
        if (genericFilterModel.SkipRecords === 0) {
          this.totalRecords = statement.TotalCount;
        }
        if (statement.Data.length > 0) {
          this.statements = [...this.statements, ...statement.Data];

          if (this.totalRecords == this.statements.length) {
            this.allDataLoaded = true;
          }
        } else {
          this.allDataLoaded = true;
        }

        if (afterLoad) {
          afterLoad();
        }
      },
      error => {
        this.loading = false;
        this.ngxService.stop();
        this.display = true;
        this.alertMessage = getErrorMessageText(error);
      });
  }

  downloadDocument(event: Event, DocSeqNum: any, FileNum: any, AppendSeqNum: any) {
    event.stopPropagation();
    event.preventDefault();
    // alert(TaxGuide);
    // this.ngxService.start();
    this.abstractDataProvider.getData('api/File/IsFileExist?SeqNum=' + DocSeqNum + '&forWhat=form')
      .subscribe(
        posts => {
          this.ngxService.stop();
          if (posts.Message) {
            this.display = true;
            this.alertMessage = posts.Message;
          } else if (posts.DocSeqNum) {
            // window.open(this.downloadDocumentImagUrl + posts.DocSeqNum + '&forWhat=form&CurrentUserNumber=' + posts.CurrentUserNumber + '&FileNum=' + FileNum + '&AppendSeqNum=' + AppendSeqNum, '_blank');
            const url = this.downloadDocumentImagUrl + posts.DocSeqNum + '&forWhat=form&CurrentUserNumber=' + posts.CurrentUserNumber + '&FileNum=' + FileNum + '&AppendSeqNum=' + AppendSeqNum;
            this.abstractDataProvider.downloadFile(url)
              .subscribe(_ => {
              }, error => {
                this.display = true;
                this.alertMessage = getErrorMessageText(error);
              });
          } else {
            // Not Found
            this.display = true;
            this.alertMessage = this.dictionaryPipe.transform('FILE_NOT_FOUND');
          }
        },
        error => {
          this.ngxService.stop();
          if (error.error && error.error.error_description) {
            this.display = true;
            this.alertMessage = error.error.error_description;
          } else {
            this.alertMessage = error.message;
          }
        }
      );
  }

  onConfirm() {
    this.display = false;
  }

  requestSearch() {
    this.searchRequest.next();
  }

  search() {
    if (this.daysToGoBack === 'DR') {
      if (!this.txtFromDistDate || !this.txtFromDistDate.Value || !this.txtToDistDate.Value) {
        return;
      }
    }
    this.currentPageNo = 1;
    this.allDataLoaded = false;
    this.statements = [];
    this.loading = true;
    this.skipRecords = 0;
    this.makeAPICallGetData(this.rowPerPage);
  }

  downloadSelected() {
    if (!this.rowSelectionList || this.rowSelectionList.length < 0) {
      this.display = true;
      this.alertMessage = this.dictionaryPipe.transform('SELECT_ANY_STATEMENTS_FOR_DOWNLOAD');
      return;
    }
    console.log(this.kendoGridComponent);

    if (this.isAllSelected) {
      this.loadMore(this.totalRecords - this.statements.length, () => {
        const fileExistInfo = this.statements
          .map((dataItem) => ({
            FileNum: dataItem.FileNum,
            SeqNum: dataItem.seqNum,
            ForWhat: 'form',
            Label: dataItem.Label,
            AppendSeqNum: dataItem.AppendSeqNum
          }));

        this.bulkDownload(fileExistInfo);
      });
    } else {
      const fileExistInfo = this.rowSelectionList
        .map(id => this.statements.find(x => x.seqNum === id))
        .map((dataItem) => ({
          FileNum: dataItem.FileNum,
          SeqNum: dataItem.seqNum,
          ForWhat: 'form',
          Label: dataItem.Label,
          AppendSeqNum: dataItem.AppendSeqNum
        }));

      this.bulkDownload(fileExistInfo);
    }
  }

  private bulkDownload(fileExistInfo) {
    this.abstractDataProvider.postData(fileExistInfo, 'api/File/IsFilesExistBulk')
      .subscribe(
        posts => {
          this.ngxService.stop();
          if (posts.Message) {
            this.display = true;
            this.alertMessage = posts.Message;
          } else if (posts.UniqueListKey) {
            const url = this.downloadDocumentImagZipUrl + posts.UniqueListKey;
            this.abstractDataProvider.downloadFile(url)
              .subscribe(_ => {
              }, error => {
                this.display = true;
                this.alertMessage = getErrorMessageText(error);
              });
          }
          // else if (posts.Data) {
          //   const foundFileList = [];
          //   let messageToShow = '';
          //   posts.Data.forEach((d) => {
          //     if (!d.IsExist) {
          //       if (messageToShow) {
          //         messageToShow += ' ; ';
          //       }
          //       messageToShow += d.Label;
          //     } else {
          //       foundFileList.push(d);
          //     }
          //   });
          //   if (messageToShow) {
          //     messageToShow = this.dictionaryPipe.transform('FILES_COULD_NOT_BE_FOUND') + messageToShow;
          //     this.display = true;
          //     this.alertMessage = messageToShow;
          //   }
          //   if (foundFileList && foundFileList.length > 0) {
          //     foundFileList.forEach((post) => {
          //       // window.open(this.downloadDocumentImagUrl + post.SeqNum + '&forWhat=form&CurrentUserNumber=' + post.CurrentUserNumber + '&FileNum=' + post.FileNum + '&AppendSeqNum=' + post.AppendSeqNum, '_blank');
          //       const url = this.downloadDocumentImagUrl + post.SeqNum + '&forWhat=form&CurrentUserNumber=' + post.CurrentUserNumber + '&FileNum=' + post.FileNum + '&AppendSeqNum=' + post.AppendSeqNum;
          //       this.abstractDataProvider.downloadFile(url)
          //         .subscribe(_ => {
          //         }, error => {
          //           this.display = true;
          //           this.alertMessage = getErrorMessageText(error);
          //         });
          //     });
          //   }
          // }
          // this.listOfSelectedStatementsForDownload = [];
          this.rowSelectionList = [];
        },
        error => {
          this.ngxService.stop();
          this.display = true;
          this.alertMessage = getErrorMessageText(error);
        }
      );
  }

  private getIntroText() {
    this.introText = this.authService.getIntroText('CLIENTSTATEMENTS');
  }

  private getGridConfig() {
    const gridColumnDetails = this.authService.getGridConfig('CLIENTSTATEMENTS');
    if (gridColumnDetails && gridColumnDetails.length > 0) {
      this.kendoGridComponent.columns.forEach((col: ColumnComponent) => {
        const colIndex = gridColumnDetails.findIndex(d => d.Field == col.field);
        if (colIndex >= 0) {
          col.title = gridColumnDetails[colIndex].Title;
        } else if (col['showSelectAll'] != 'true') {
          col.hidden = true;
        }
      });
    }
  }

  onFilterChange() {
    this.requestSearch();
  }
}
